import 'bootstrap';

window.Vue = require('vue');
require('./plugins');
require('./components');
require('./views');
